import AxiosClientService from '@/services/core/axios/axios';
import { APP_HOST } from '@/app.config';

class NosologyApi {
  constructor() {
    this.api = AxiosClientService.instance;
  }
  /**
   *  Метод для получения списка нозологий
   * @param {Object} params - Параметры запроса
   * @param {string} params.nosologyName - Строка поиска
   * @param {number} params.page - Номер страницы
   * @param {number} params.limit - Количество нозологий на странице
   * @returns
   */

  async getNosologyList(params) {
    const { data } = await this.api.get(`${APP_HOST}nosology/list`, { params });
    return data;
  }

  /**
   *  Метод для получения нозологии по ID
   * @param {string} id - ID нозологии
   * @returns
   */
  async getNosologyById(id) {
    const { data } = await this.api.get(`${APP_HOST}nosology/${id}`);
    return data;
  }

  /**
   *  Метод для создания нозологии
   * @param {Object} params - Параметры запроса
   * @param {string} params.name - Наименование нозологии
   * @param {Array} params.diagnoses - Массив диагнозов
   * @param {string} params.description - Описание нозологии
   * @returns
   */
  async createNosology(params) {
    const { data } = await this.api.post(`${APP_HOST}nosology`, params);
    return data;
  }

  /**
   *  Метод для удаления нозологии
   * @param {string} id - ID нозологии
   * @returns
   */
  async deleteNosology(id) {
    const { data } = await this.api.delete(`${APP_HOST}nosology/${id}`);
    return data;
  }

  /**
   *  Метод для обновления нозологии
   * @param {string} id - ID нозологии
   * @param {Object} params - Параметры запроса
   * @param {string} params.name - Наименование нозологии
   * @param {Array} params.diagnoses - Массив диагнозов
   * @param {string} params.description - Описание нозологии
   * @returns
   */
  async updateNosology(id, params) {
    const { data } = await this.api.put(`${APP_HOST}nosology/${id}`, params);
    return data;
  }

  /**
   *  Метод для получения короткого списка нозологий
   * @returns
   */
  async getShortNosologyList() {
    const { data } = await this.api.get(`${APP_HOST}nosology/list/short`);
    return data;
  }
}
export default NosologyApi;
